// src/api/useFetchObjects.js
import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const useFetchObjects = (queryKey, endpoint, token, options = {}) => {
  // TanStack Query v4+ requires queryKey to be an array; normalize and support disabled fetch
  const effectiveKey = Array.isArray(queryKey)
    ? queryKey
    : queryKey != null
      ? [queryKey]
      : ["disabled"];
  const shouldEnable =
    options.enabled !== undefined ? options.enabled : queryKey != null && endpoint !== "";

  const fetchFunction = async () => {
    const headers = token ? { Authorization: `Token ${token}` } : {};
    const response = await axios.get(
      `${endpoint}`,
      { headers }
    );
    return response.data;
  };

  const { data, isLoading, isError, isSuccess, error, refetch } = useQuery({
    queryKey: effectiveKey,
    queryFn: fetchFunction,
    enabled: shouldEnable,
    ...options,
  });

  return { data, isLoading, isError, isSuccess, error, refetch };
};

export default useFetchObjects;
